import { createRoot } from 'react-dom/client';
import { AnalyticsProvider } from 'use-analytics';

import PackWrapper from 'components/common/PackWrapper';
import MessageCenterContainer from 'components/messageCenter/MessageCenterContainer';
import pixelAnalytics from 'helpers/analytics/pixelAnalytics';
import { getStore } from 'store/configure';

const store = getStore();

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.querySelector('#hc-notifications-react-app');
  const root = createRoot(rootElement);

  root.render(
    <PackWrapper rootElement={rootElement} store={store} withRouter={false}>
      <App rootElement={rootElement} />
    </PackWrapper>
  );
});

const App = ({ rootElement }) => (
  <AnalyticsProvider
    instance={pixelAnalytics({
      canTrack: rootElement?.getAttribute('data-can-track') === 'true',
    })}
  >
    <MessageCenterContainer />
  </AnalyticsProvider>
);

App.propTypes = {
  rootElement: PropTypes.object,
};
